export default __webpack_public_path__ + "static/B0030-f2bc21fad6e170641504d7a0888b355e.png";